import { useCallback } from 'react'
import clsx from 'clsx'
import { NavLink } from 'react-router-dom'

import { cn } from 'utils/cn'

type Props = {
  link?: string
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
  className?: string

  children: React.ReactNode
}

export function SidebarLink(props: Props) {
  const { link, children, icon: Icon, className } = props

  const generateItemClassName = useCallback(
    (params: { isActive?: boolean; isPending?: boolean; className?: string; header?: boolean }) =>
      cn(
        params.isActive ? 'bg-gray-200 ' : 'hover:bg-gray-100',
        params.header ? 'text-gray-600 font-semibold hover:bg-inherit cursor-default' : '',
        'group flex gap-x-4 rounded px-2 py-1 text-xs leading-6 relative',
        params.className,
        className
      ),
    [className]
  )

  const linkContent = (
    <>
      {Icon && <Icon className={clsx('h-6 w-6 shrink-0')} aria-hidden="true" />}
      {children}
    </>
  )

  if (!link) return <div className={generateItemClassName({ className, header: true })}>{linkContent}</div>

  return (
    <NavLink to={link} className={generateItemClassName}>
      {linkContent}
    </NavLink>
  )
}
